export const keyboardEvents = {
  ENTER: 'Enter',
  ESC: 'Escape',
  ARROW_DOWN: 'ArrowDown',
  ARROW_UP: 'ArrowUp',
}
